import { createFrontendModule } from "@backstage/frontend-plugin-api";
import { HomePageLayoutBlueprint } from "@backstage/plugin-home-react/alpha";

import { HomePage } from "./components/HomePage";

/**
 * Home page layout extension.
 *
 * Overrides the default `home-page-layout:home` extension with Banno's custom
 * {@link HomePage} component, which includes:
 * - Company logo with search bar
 * - Catalog onboarding quick-start card
 * - Announcements card
 * - Configurable dashboard grid (visited pages, starred entities, toolkit, jokes)
 */
const homePageLayout = HomePageLayoutBlueprint.make({
    params: {
        loader: async () => HomePage,
    },
});

/**
 * Frontend module that overrides the home plugin's page layout with Banno's
 * custom home page.
 *
 * Migrated from `packages/app/src/modules/home/homeModule.ts` and
 * `packages/app/src/components/home/`.
 */
const appModuleHome = createFrontendModule({
    pluginId: "home",
    extensions: [homePageLayout],
});

export default appModuleHome;
